import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isNotFound = (response: HttpErrorResponse): boolean => {
  return response.status === HttpStatusCode.NotFound;
};
